import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import GuideRenderer from '../components/GuideRenderer';
import API_BASE_URL from '../config';

function GuidePage() {
  var { slug } = useParams();
  var [guide, setGuide] = useState(null);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState(false);

  useEffect(function () {
    setLoading(true);
    setError(false);
    fetch(API_BASE_URL + '/api/guides/' + slug)
      .then(function (r) {
        if (!r.ok) throw new Error('Not found');
        return r.json();
      })
      .then(function (data) {
        var g = data.guide;
        // Normalize snake_case API fields to match GuideRenderer expectations
        setGuide({
          slug: g.slug,
          title: g.title,
          seoTitle: g.seo_title || g.title,
          seoDescription: g.seo_description || g.excerpt,
          excerpt: g.excerpt,
          tag: g.tag,
          date: g.date,
          readTime: g.read_time,
          content: g.content || [],
        });
        setLoading(false);
      })
      .catch(function () {
        setError(true);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="content-page">
        <div className="container" style={{ textAlign: 'center', padding: '4rem 1rem' }}>
          <p style={{ color: 'var(--text-muted, #888)' }}>Loading guide…</p>
        </div>
      </div>
    );
  }

  if (error || !guide) {
    return (
      <div className="content-page">
        <div className="container">
          <h1>Guide Not Found</h1>
          <p>Sorry, we couldn't find that guide.</p>
          <Link to="/learn" className="btn btn-primary">Back to Learn</Link>
        </div>
      </div>
    );
  }

  return <GuideRenderer guide={guide} />;
}

export default GuidePage;
